export const refreshList = isRefreshList => dispatch => dispatch({ type: 'LOAD_DATA', isRefreshList });
export const refreshAll = isRefreshAll => dispatch => dispatch({ type: 'LOAD_DATA', isRefreshAll });
